import { BlockStack, Card, Layout, SkeletonBodyText, SkeletonDisplayText, SkeletonPage } from '@shopify/polaris'
import i18next from 'i18next'

const LocalizationFallback = () => {
  return (
    <SkeletonPage title={i18next.t('localisationTitle')}>
      <Layout>
        <Layout.AnnotatedSection title={i18next.t('localisationDateTitle')} description={i18next.t('localisationDateDescription')}>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.AnnotatedSection>
        <Layout.AnnotatedSection title={i18next.t('localisationLabelsTitle')} description={i18next.t('localisationLabelsDescription')}>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
                <SkeletonDisplayText size="small" />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.AnnotatedSection>
      </Layout>
    </SkeletonPage>
  )
}

export { LocalizationFallback }
